export default __webpack_public_path__ + "41161cefbd475a9a84a65b425e9d7f31.jpg";